/* eslint-disable react/button-has-type */
/* eslint-disable react/require-default-props */
import React from 'react';
import { Button } from './styles';

interface AcademyButtonProps {
  variant?: 'primary' | 'outline';
  icon?: string;
  imgIcon?: string;
  onClick?: () => void;
  children: React.ReactNode;
  block?: boolean;
  type?: 'button' | 'submit';
  disabled?: boolean;
}

const AcademyButton: React.FC<AcademyButtonProps> = ({
  variant = 'primary',
  icon,
  imgIcon,
  onClick,
  children,
  block = false,
  type = 'button',
  disabled = false,
}) => {
  return (
    <Button type={type} variant={variant} block={block} onClick={onClick} disabled={disabled}>
      {imgIcon && <img className="academy-btn-icon" src={imgIcon} alt="" />}
      {!imgIcon && icon && <i className="material-icons">{icon}</i>}
      {children}
    </Button>
  );
};

export default AcademyButton;
